import ImageStyles from "./ImageStyles";

export default ImageStyles;
